<template>
    <div class="stock-distribution">
        <compWrapper title="基本信息" theme="primary">
            <div style="margin-top: 15px; padding: 0 15px">
                <compFormQuery
                    :labelWidth="140"
                    v-if="this.type == 'query'"
                    :col="1"
                    :value="formData"
                    :formdata="getBase"
                ></compFormQuery>
                <compFormEdit
                    :labelWidth="140"
                    v-else
                    ref="validForm"
                    :col="1"
                    v-model="formData"
                    :formdata="getBase"
                ></compFormEdit>
                <vFormItem
                    :labelWidth="140"
                    label="参与库存分配的仓库"
                    :rules="type == 'query' ? '' : required"
                    prop="type"
                >
                    <div v-if="type != 'query'">
                        <vRadio
                            trueValue="1"
                            :strict="false"
                            v-model="warehouseType"
                            class="margin-right-10"
                            >所有虚拟仓和服务仓</vRadio
                        >
                        <vRadio
                            trueValue="0"
                            :strict="false"
                            v-model="warehouseType"
                            class="margin-right-10"
                            >指定仓库</vRadio
                        >
                    </div>
                    <div v-else>
                        <a class="font-weight" @click="handleWarehouseModal">{{
                            warehouseType == "1"
                                ? "所有虚拟仓和服务仓"
                                : "指定仓库"
                        }}</a>
                    </div>
                    <!-- <vRadio
                    trueValue="2"
                    :strict="false"
                    v-model="warehouseType"
                    class="margin-right-10"
                    >指定仓库组</vRadio
                >
                <vSelect
                    v-if="formData.type == 2"
                    style="width: 200px; display: inline-block"
                    v-model="warehouseGroup"
                >
                    <vOptions
                        v-for="item in warehouseGroupList"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</vOptions
                    >
                </vSelect> -->
                    <vTransfer
                        v-if="warehouseType == 0 && type != 'query'"
                        style="margin-top: 15px; height: 360px"
                        :data="warehouses"
                        :target-keys="warehouseKeys"
                        :list-style="listStyle"
                        :render-format="renderFormat"
                        filterable
                        @on-transfer="handleWarehouseChange"
                        :filter-method="filterMethod"
                    ></vTransfer>
                </vFormItem>
            </div>
            <div v-if="type != 'query'" slot="footer">
                <Button class="margin-right-15" type="primary" @click="submit"
                    >保存</Button
                >
                <Button @click="cancel">取消</Button>
            </div>
        </compWrapper>
        <compWrapper title="分配比例" theme="info">
            <compFormQuery
                class="margin-top-15"
                :labelWidth="100"
                v-if="this.type == 'query'"
                :col="1"
                :value="formData"
                :formdata="getAcc"
            ></compFormQuery>
            <Table
                class="margin-15"
                border
                :max-height="type == 'query' ? 400 : ''"
                size="small"
                :data="tableData"
                :columns="columns"
            ></Table>
        </compWrapper>
        <compWrapper v-if="type == 'query'" title="操作历史" theme="gray">
            <compLog :data="logList" :columns="logcolumns"></compLog>
        </compWrapper>
        <compModal v-model="operate.show" v-bind="operate" v-on="operate.on">
            <component
                v-if="operate.component"
                :is="operate.component"
                v-bind="operate"
                v-on="operate.on"
                @on-close="operate = {}"
            />
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import mixin from "./mixin";
import compWarehouseList from "./warehouselist";
import { HttpWarehouseList } from "@mods/service/dictionary";
import {
    HttpSaveStockDistributionData,
    HttpGetStockDistribution,
    HttpSysOpLog,
} from "@/service/stockdistribution/index";
import { mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    mixins: [mixin],
    components: {
        compWarehouseList,
    },
    data() {
        return {
            id: this.activeid || this.$route.query.id,
            type: this.querytype || this.$route.params.type,
            formData: {},
            warehouses: [],
            warehouseType: 1,
            warehouseGroup: "",
            warehouseGroupList: [],
            warehouseKeys: [],
            orgWarehouseIds: [],
            required: [
                {
                    required: true,
                    message: "此项不能为空，请填写",
                },
            ],
            tableData: [],
            logList: [],
            operate: {
                show: false,
            },
            listStyle: {
                width: "30%",
                minWidth: "260px",
            },
            loading: false,
        };
    },
    watch: {
        warehouseType: {
            immediate: true,
            handler(warehouseType) {
                // 选中了指定仓库
                if (warehouseType == 0) {
                    if (this.orgWarehouseIds) {
                        this.warehouseKeys = this.orgWarehouseIds
                            .split(",")
                            .map((item) => {
                                return parseInt(item);
                            });
                    }
                } else {
                    // 切换时需要重置选中的仓库
                    // this.formData.orgWarehouseIds = "";
                    this.orgWarehouseIds = "";
                    this.warehouseKeys = [];
                }
            },
        },
        getAccountList: {
            immediate: true,
            handler(val) {
                if (this.type == "add") {
                    this.tableData = this.getAccountList
                        .filter((item) => {
                            return item.attach.status != "inactive";
                        })
                        .map((item) => {
                            return {
                                accountId: item.value,
                                accountFlag: item.attach.flag,
                                accountType: item.attach.type,
                                accountTitle: item.attach.title,
                                assignPercent: null,
                                adjustValue: null,
                            };
                        });
                }
            },
        },
    },
    async created() {
        // this.warehouses = this.getWarehouseList.filter(item => {
        //     return item.warehouseType === 1 || item.warehouseType === 5;
        // }).map(item => {
        //     return {
        //         label: item.label,
        //         key: item.value,
        //     };
        // });
        this.getWarehouse();
        if (this.type != "add") {
            this.loading = true;
            await this.getDetail();
            await this.getLog();
            this.loading = false;
        } else {
            this.tableData = this.getAccountList
                .filter((item) => {
                    return item.attach.status != "inactive";
                })
                .map((item) => {
                    return {
                        status: item.attach.status,
                        accountId: item.value,
                        accountFlag: item.attach.flag,
                        accountType: item.attach.type,
                        accountTitle: item.attach.title,
                        assignPercent: null,
                        adjustValue: null,
                    };
                });
        }
    },
    computed: {
        ...mapGetters("diction", ["getNewDifferentAllProductList"]),
        ...mapGetters("dictionary", ["getAccountList", "getWarehouseList"]),
        getBase() {
            let isQuery = this.type == "query";
            let widthStyle = "width: 50%;";
            return [
                {
                    label: "模板名称",
                    key: "templateName",
                    tag: "vInput",
                    query: isQuery,
                    style: widthStyle,
                },
                {
                    label: "模板类型",
                    key: "type",
                    tag: "vSelect",
                    options: this.templateType,
                    query: this.type != "add",
                    style: widthStyle,
                },
                {
                    label: "项目",
                    key: "lineId",
                    tag: "vSelect",
                    show: this.formData.type == 1,
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query: this.type != "add",
                    options: this.getNewDifferentAllProductList,
                    style: widthStyle,
                },
                {
                    label: "ERPSKU",
                    tag: "div",
                    key: "erpSku",
                    show: this.formData.type == 2,
                    removeInput: true,
                    children: (h) => {
                        return h("compErpSkuInput", {
                            props: {
                                value: this.formData.erpSku,
                                // showread: "showyes"
                            },
                            on: {
                                "on-data": (row) => {
                                    this.$set(
                                        this.formData,
                                        "erpSku",
                                        row.erpSku
                                    );
                                    this.$set(
                                        this.formData,
                                        "lineId",
                                        row.lineId
                                    );
                                    // this.formData.erpSku = row.erpSku;
                                },
                            },
                        });
                    },
                    required: true,
                    query: this.type != "add",
                    style: widthStyle,
                },
                {
                    label: "模板描述",
                    key: "description",
                    tag: "vTextarea",
                    query: this.isQuery,
                    required: false,
                    style: widthStyle,
                },
            ];
        },
        getAcc() {
            let isQuery = this.type == "query";
            let widthStyle = "width: 50%;";
            return [
                {
                    label: "分配比例总计",
                    key: "assignPercent",
                    tag: "vInput",
                    query: isQuery,
                    style: widthStyle,
                },
            ];
        },
        columns() {
            return [
                {
                    title: "店铺名称",
                    key: "accountFlag",
                    render: (h, { row }) => {
                        return <div>{row.accountFlag}{row.status == 'inactive' ? <span class="color-error">停用</span> : ""}</div>
                    },
                },
                {
                    title: "店铺类型",
                    key: "accountType",
                },
                {
                    title: "分配比例(%)",
                    key: "assignPercent",
                    sortable: this.type == "query",
                    sortType: this.type == "query" ? "desc" : "",
                    render: (h, { row, index }) => {
                        if (this.type != "query") {
                            return h("InputNumber", {
                                props: {
                                    min: 0,
                                    value: this.tableData[index].assignPercent,
                                    size: "small",
                                },
                                style: {
                                    width: "100%",
                                },
                                on: {
                                    "on-change": (val) => {
                                        this.tableData[index].assignPercent =
                                            val;
                                    },
                                },
                            });
                        } else {
                            return (
                                <div>{this.tableData[index].assignPercent}</div>
                            );
                        }
                    },
                },
                {
                    title: "调整值",
                    key: "adjustValue",
                    render: (h, { row, index }) => {
                        if (this.type != "query") {
                            return h("InputNumber", {
                                props: {
                                    value: this.tableData[index].adjustValue,
                                    size: "small",
                                },
                                style: {
                                    width: "100%",
                                },
                                on: {
                                    "on-change": (val) => {
                                        this.tableData[index].adjustValue = val;
                                    },
                                },
                            });
                        } else {
                            return (
                                <div>{this.tableData[index].adjustValue}</div>
                            );
                        }
                    },
                },
            ];
        },
    },
    methods: {
        async getWarehouse() {
            await HttpWarehouseList().then(
                (res) => {
                    this.warehouses = res.data
                        .filter((item) => {
                            return (
                                item.warehouseType === 1 ||
                                item.warehouseType === 5
                            );
                        })
                        .map((item) => {
                            return {
                                label: item.title
                                    ? `${item.code}(${item.title})`
                                    : item.code,
                                key: item.id,
                                attach: {
                                    code: item.code,
                                    warehouseType: item.warehouseType,
                                },
                            };
                        });
                },
                (err) => {
                    this.$VMessage.error(err);
                }
            );
        },
        handleWarehouseModal() {
            this.operate = {
                show: true,
                width: 600,
                title: "展示仓库",
                component: "compWarehouseList",
                showFooter: false,
                orgWarehouseIds: this.orgWarehouseIds,
                warehouseType: this.warehouseType,
            };
        },
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod(data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        handleWarehouseChange(targetKeys, direction, moveKeys) {
            this.warehouseKeys = targetKeys;
            // this.formData.orgWarehouseIds = targetKeys.join(',');
            this.orgWarehouseIds = targetKeys.join(",");
        },
        async getDetail() {
            await HttpGetStockDistribution({
                id: this.id,
            }).then(
                (res) => {
                    let {
                        stockBaseTemplateItems,
                        orgWarehouseType,
                        orgWarehouseIds,
                        ...formData
                    } = {
                        ...res.data,
                    };
                    this.tableData = stockBaseTemplateItems;
                    this.formData = formData;
                    // this.formData.orgWarehouseIds = orgWarehouseIds;
                    this.orgWarehouseIds = orgWarehouseIds;
                    this.warehouseType = orgWarehouseType;
                    // this.$set(this, 'warehouseKeys', orgWarehouseIds.split(',').map(item => {
                    //     return parseInt(item);
                    // }));
                    // this.warehouseKeys = orgWarehouseIds.split(',').map(item => {
                    //     return parseInt(item);
                    // });
                    console.log(this.warehouseKeys);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getLog() {
            await HttpSysOpLog({
                "search[EQ_opDataId]": this.id,
                "search[EQ_opModel]": "Base_Template",
            }).then(
                (res) => {
                    this.logList = res.data.content;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async submit() {
            await this.$refs.validForm.validate();
            let requestData = {
                ...this.formData,
                id: this.id || null,
                orgId: global.SYSID,
                orgWarehouseType: this.warehouseType,
                orgWarehouseIds: this.orgWarehouseIds,
                stockBaseTemplateItems: this.tableData,
            };
            // return console.log(this.formData, requestData);
            if (this.type == "add") delete requestData.id;
            let ajaxRequest = () => {
                HttpSaveStockDistributionData(requestData).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.operate.show = false;
                        this.cancel();
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            };
            await this.validTablePercent().then(
                () => {
                    // 通过验证，小于100
                    ajaxRequest();
                },
                () => {
                    // 未通过验证，大于100
                    this.operate = {
                        show: true,
                        title: "提示",
                        alert: "warning",
                        desc: "分配比例大于100%，是否确认继续？",
                        width: 600,
                        showFooter: true,
                        params: {
                            id: this.id,
                        },
                        on: {
                            "on-confirm": () => {
                                ajaxRequest();
                            },
                        },
                    };
                }
            );
        },
        validTablePercent() {
            let promise = new Promise((resolve, reject) => {
                let percent = 0;
                this.tableData.map((item) => {
                    if (!item.assignPercent) return;
                    percent += parseFloat(item.assignPercent);
                });
                console.log("percent", percent);
                if (percent == 0)
                    return this.$VMessage.error("必须有店铺分配比例不为0");

                if (percent > 100) return reject();
                return resolve();
            });
            return promise;
        },
        cancel() {
            if (this.querytype) {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "stockDistributionList",
                });
            }
        },
    },
};
</script>

<style>
</style>
